import { useState } from 'react';
import { Link } from 'react-router';
import './RecentCalls.css';
import { listLocalCalls } from '../../lib/calls.ts';
import { formatRelativeAge } from '../../lib/formatting.ts';

/**
 * The last few calls made in this browser.
 *
 * Local by design — it is a scratchpad, not a leaderboard, and reading it from
 * the database would cost a Worker invocation on every page load for something
 * only the current user cares about. `/record` is where the global view lives.
 */
export function RecentCalls({ limit = 5 }: { limit?: number }) {
  // Read once, lazily, at first render. localStorage is synchronous and there
  // is no server render to mismatch against, so an effect would only add a
  // wasted second pass.
  const [calls] = useState(() => listLocalCalls().slice(0, limit));

  if (calls.length === 0) return null;

  return (
    <section className="recent" aria-labelledby="recent-title">
      <h2 className="recent__title mono-label" id="recent-title">
        Your recent calls
      </h2>
      <ul className="recent__list">
        {calls.map((call) => (
          <li key={call.id}>
            <Link className="recent__item" to={`/call/${call.id}`}>
              <span className={`recent__dir recent__dir--${call.direction.toLowerCase()}`}>
                {call.direction}
              </span>
              {/* Only imported historical calls carry a market. */}
              <span className="recent__asset">{call.asset ?? call.id}</span>
              <span className="recent__age">{formatRelativeAge(call.createdAt)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
